import { action } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsPaymentStore {
  @action pay(request) {
    return apiCaller.CmsPayment.ird(request).then(resp => {
      return resp;
    });
  }
}

export default new CmsPaymentStore();